export default __webpack_public_path__ + "abef0d5ca628b22aaf1a65a682cd1e36.svg";